import { QueryClient, QueryClientProvider as QueryClientProviderOriginal } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: (_error, query) => query.state.data === undefined,
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
      // onError: (err: any) => {
      //   const isString = typeof err?.message === "string";
      //   toast.show(isString ? err?.message : "Er ging iets fout");
      // },
    },
  },
});

export default function QueryClientProvider({ children }: { children: any }) {
  return <QueryClientProviderOriginal client={queryClient}>{children}</QueryClientProviderOriginal>;
}
